import { Route, Routes } from "react-router-dom";
import SupplierOnboardingPage from "./onboarding";
import SupplierDetail from "./onboarding/SupplierDetail";
import SupplierDetailPage from "./SupplierDetailPage";
import SupplierListPage from "./SupplierListPage";

const SuppliersPage = () => {
  return (
    <Routes>
      <Route index element={<SupplierListPage />} />
      <Route path=":id" element={<SupplierDetailPage />} />
      <Route path="onboarding" element={<SupplierOnboardingPage />} />
      <Route path="onboarding/:id" element={<SupplierDetail />} />
    </Routes>
  );
};

export default SuppliersPage;
